// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4dd5d9a4","239":"c21e49e9","732":"37dc6654","977":"b2ed2fab"}[chunkId] + ".chunk.js";
};